import {
  Spacer,
  TitleCell,
  TitleRow
} from '../../../../components/ReusableComponents/Table'

const PMSBEHealthTitleRow = ({ hideStopTestLogin = false }) => {
  if (hideStopTestLogin) {
    return (
      <TitleRow style={{ position: 'sticky', top: 70 }}>
        <TitleCell>Id</TitleCell>
        <TitleCell>Hotel name</TitleCell>
        <Spacer />
        <TitleCell>CSM</TitleCell>
        <TitleCell textAlign="center">PMS Sync</TitleCell>
        <TitleCell>Last SYNC</TitleCell>
        <TitleCell>
          Reports for <br /> last 48h
        </TitleCell>
        <TitleCell>PMS</TitleCell>
        <TitleCell>Last result</TitleCell>
        <TitleCell>Notes</TitleCell>
      </TitleRow>
    )
  }

  return (
    <TitleRow style={{ position: 'sticky', top: 70 }}>
      <TitleCell>Id</TitleCell>
      <TitleCell>Hotel name</TitleCell>
      <Spacer />
      <TitleCell>CSM</TitleCell>
      <TitleCell textAlign="center">PMS Sync</TitleCell>
      <TitleCell>Last SYNC</TitleCell>
      <TitleCell>
        Reports for <br /> last 48h
      </TitleCell>
      <TitleCell>PMS</TitleCell>
      <TitleCell>Last result</TitleCell>
      <TitleCell textAlign="center">Stop / Test login</TitleCell>
      <TitleCell>Notes</TitleCell>
    </TitleRow>
  )
}

export default PMSBEHealthTitleRow
